import { createFileRoute } from '@tanstack/react-router';

import { OrganisationsListPage } from '@organisations/feature';

export const Route = createFileRoute('/_app/_admin/organisations')({
  component: OrganisationsListPage,
});
